module.exports = __webpack_public_path__ + "img/widget_cal.3d348dc1.svg";